import * as React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import type {
  ScheduledInventoryDailyItemsIntegralReport as Report,
} from 'contracts/scheduled-reports';
import { notify } from 'services/notifications';
import { downloadScheduledReport } from 'utils';
import {
  useCreateScheduledReport,
  useFetchScheduledReports,
} from 'hooks/api/scheduled-reports';
import { Scaffold } from 'layouts';
import { Button } from 'components/ui/button';
import {
  TabbedNavigation,
} from 'pages/scheduled-reports/shared-components';
import { DataTableV2 } from 'components/ui/DataTableV2';

import { useInventoryDailyItemsIntegralReportColumns } from './hooks';

export const InventoryDailyItemsIntegralReportsPage = () => {
  const queryClient = useQueryClient();
  const { fetchScheduledReports } = useFetchScheduledReports<Report>();
  const { createScheduledReport } = useCreateScheduledReport();

  const columns = useInventoryDailyItemsIntegralReportColumns({
    onClickDownload: downloadScheduledReport,
  });

  const reportsQuery = useQuery({
    queryKey: ['fetch-inventory-daily-items-integral-reports'],
    initialData: [],
    queryFn: () => fetchScheduledReports({
      type: 'inventory-daily-items-integral',
    }),
  });

  const createReportMutation = useMutation({
    mutationKey: ['create-scheduled-inventory-daily-items-integral-report'],
    mutationFn: createScheduledReport,
    onSuccess: () => {
      notify('success', 'Relatório requisitado com sucesso.');
      queryClient.invalidateQueries(['fetch-inventory-daily-items-integral-reports']);
    },
    onError: (error: any) => {
      notify('error', error?.message);
    },
  });

  const handleRequestReport = React.useCallback(() => {
    createReportMutation.mutate({
      type: 'inventory-daily-items-integral',
      params: {},
    });
  }, [createReportMutation]);

  return (
    <Scaffold>
      <TabbedNavigation />
      <div className={'flex flex-col gap-6'}>
        <div className={'flex justify-end'}>
          <Button
            type={'button'}
            onClick={handleRequestReport}
            disabled={createReportMutation.isLoading}
          >
            Requisitar relatório
          </Button>
        </div>
        <DataTableV2
          columns={columns}
          data={reportsQuery?.data ?? []}
        />
      </div>
    </Scaffold>
  );
};
